(function () {
  if (window.__aurelleEventsLoaded) return;
  window.__aurelleEventsLoaded = true;

  function clean(value) {
    if (value == null) return undefined;
    return String(value).trim() || undefined;
  }

  function toSnake(value) {
    return String(value || '')
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .replace(/[-\s]+/g, '_')
      .toLowerCase();
  }

  function datasetPayload(el) {
    var payload = {};
    if (!el || !el.dataset) return payload;

    Object.keys(el.dataset).forEach(function (key) {
      if (key.indexOf('aurelle') !== 0) return;
      var rawName = key.replace(/^aurelle/, '');
      if (!rawName) return;
      var name = toSnake(rawName);
      payload[name] = clean(el.dataset[key]);
    });

    return payload;
  }

  function trackingPayload(el) {
    return Object.assign(datasetPayload(el), {
      source: clean(el.getAttribute('data-source')) || clean(el.getAttribute('data-aurelle-source')) || undefined,
      product_id: clean(el.getAttribute('data-product-id')) || clean(el.getAttribute('data-aurelle-product-id')) || undefined,
      product_handle: clean(el.getAttribute('data-product-handle')) || clean(el.getAttribute('data-aurelle-product-handle')) || undefined,
      product_title: clean(el.getAttribute('data-product-title')) || clean(el.getAttribute('data-aurelle-product-title')) || undefined
    });
  }

  function basePayload() {
    return {
      path: window.location.pathname,
      search: window.location.search || undefined,
      title: document.title || undefined,
      ts: new Date().toISOString()
    };
  }

  window.aurelleTrack = function (eventName, payload) {
    if (!eventName) return;

    var data = Object.assign(basePayload(), payload || {});
    var finalName = eventName.indexOf('aurelle_') === 0 ? eventName : 'aurelle_' + eventName;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: finalName }, data));

    try {
      window.dispatchEvent(new CustomEvent(finalName, { detail: data }));
    } catch (err) {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(finalName, false, false, data);
      window.dispatchEvent(evt);
    }
  };

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-aurelle-track], a[href]');
    if (!el) return;

    var action = el.getAttribute('data-aurelle-track');
    var href = clean(el.getAttribute('href'));
    if (!action && href) {
      if (href.indexOf('/pages/fit-guide') !== -1) action = 'fit_guide_click';
      if (href.indexOf('/pages/creators') !== -1 || href.indexOf('/pages/creator-programme') !== -1) action = 'creator_link_click';
      if (href.indexOf('#first-access') !== -1) action = 'waitlist_click';
      if (href.indexOf('#size-fit') !== -1) action = 'size_fit_anchor_click';
      if (href.indexOf('/pages/shipping-returns') !== -1) action = 'shipping_returns_click';
    }
    if (!action) return;

    window.aurelleTrack(action, Object.assign(trackingPayload(el), {
      text: clean(el.textContent),
      href: href
    }));
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;

    var formType = form.getAttribute('data-aurelle-form');
    if (!formType && form.closest('.aurelle-creator-form')) formType = 'creator';
    if (!formType && form.classList.contains('aurelle-waitlist__form')) formType = 'waitlist';
    if (!formType && form.classList.contains('aurelle-email-capture__form')) formType = 'email-capture';
    if (!formType) return;

    var wrapper = form.closest('[data-aurelle-email-capture], .aurelle-waitlist, .aurelle-creator-form');
    var source = wrapper ? clean(wrapper.getAttribute('data-source')) || clean(wrapper.getAttribute('data-aurelle-source')) || clean(wrapper.getAttribute('data-aurelle-waitlist-source')) : undefined;
    var eventName = 'email_submit';

    if (formType === 'creator' || source && source.indexOf('creator') !== -1) eventName = 'creator_submit';
    else if (source && source.indexOf('pdp') !== -1) eventName = 'waitlist_submit';
    else if (source && source.indexOf('first-access') !== -1) eventName = 'first_access_submit';
    else if (formType === 'waitlist') eventName = 'waitlist_submit';

    window.aurelleTrack(eventName, Object.assign(trackingPayload(wrapper || form), {
      form_type: formType,
      form_id: clean(form.getAttribute('id')),
      form_action: clean(form.getAttribute('action'))
    }));
  }, true);

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-aurelle-chip]');
    if (!chip) return;

    var controls = chip.closest('[data-aurelle-archive-controls]');
    if (!controls) return;

    var value = chip.getAttribute('data-aurelle-chip') || 'all';
    var section = controls.closest('.shopify-section') || document;
    var cards = section.querySelectorAll('[data-aurelle-product-card]');

    if (!cards.length) {
      cards = document.querySelectorAll('[data-aurelle-product-card]');
    }

    controls.querySelectorAll('[data-aurelle-chip]').forEach(function (node) {
      node.classList.toggle('is-active', node === chip);
    });

    cards.forEach(function (card) {
      var kind = card.getAttribute('data-aurelle-kind') || '';
      var show = value === 'all' || kind.indexOf(value) !== -1;
      card.hidden = !show;
    });

    window.aurelleTrack('archive_chip_click', {
      chip: value,
      source: 'collection',
      path: window.location.pathname
    });
  }, true);

  function observeOnce(selector, eventName) {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      window.aurelleTrack(eventName, { source: selector, observer_fallback: true });
      return;
    }

    var seen = new WeakSet();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        seen.add(entry.target);
        window.aurelleTrack(eventName, datasetPayload(entry.target));
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    nodes.forEach(function (node) { observer.observe(node); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeOnce('[data-aurelle-observe="first_access"], #first-access', 'first_access_view');
    observeOnce('[data-aurelle-observe="trust_bar"]', 'trust_bar_view');
    observeOnce('[data-aurelle-observe="pdp_specs"]', 'pdp_specs_view');

    if (window.location.pathname === '/pages/creators') {
      window.aurelleTrack('creator_page_view', { source: 'page' });
    }

    var marketSelectors = document.querySelectorAll('localization-form, .localization-form, [data-localization-form], [aria-controls*="Country"], [aria-controls*="country"]');
    marketSelectors.forEach(function (el) {
      el.addEventListener('click', function () {
        window.aurelleTrack('market_selector_open', datasetPayload(el));
      }, { once: true });
    });
  });
})();
